import { useEffect } from "react"
import { useLocation } from "react-router-dom"

import { setAnchor } from "shared/lib/navigation/navigationAnchor"
import { AnchorType } from "shared/types/NavigationAnchor"

export function useAnchor(type: AnchorType) {
  const { pathname } = useLocation()
  useEffect(() => {
    setAnchor(type, pathname)
  }, [])
}
